module.exports = __webpack_public_path__ + "img/exhibition_icon_gongxu.7c769a50.png";